export default __webpack_public_path__ + "static/media/franchising-img2.3bf9015f.png";